<template><div><h1>异步加载组件</h1>
<p>将所有页面组件一次性加载是一个很浪费资源和考验用户耐心的做法，尤其在移动端。</p>
<h2>使用方法</h2>
<p><code>webpack</code> 提供了<a href="https://webpack.js.org/guides/code-splitting-require/">code splitting</a>，你可以按照下面写法实现当切换到特定路由时才加载代码。</p>
<p>需要注意的是 <code>vue-loader@13.0.0</code> 语法有所变更，具体参照发布说明 <a href="https://github.com/vuejs/vue-loader/releases/tag/v13.0.0">v13.0.0</a></p>
<pre class="hljs"><code><span class="hljs-comment">// vue-loader@13.0.0 之前</span>
<span class="hljs-keyword">const</span> Foo = <span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> <span class="hljs-keyword">import</span>(<span class="hljs-string">'./Foo.vue'</span>) <span class="hljs-comment">// 在 Vue 2.4 + vue-router 2.7 版本下可以正确运行</span>

<span class="hljs-comment">// vue-loader@13.0.0</span>
<span class="hljs-keyword">const</span> Foo = <span class="hljs-function"><span class="hljs-params">()</span> =&gt;</span> <span class="hljs-keyword">import</span>(<span class="hljs-string">'./Foo.vue'</span>).then(<span class="hljs-function"><span class="hljs-params">m</span> =&gt;</span> m.default)
</code></pre>
<h2>组件打包问题</h2>
<p>如果你在不同的进行了代码分割的 .vue 文件引入了相同的组件，在打包时两个路由的代码都会重复打包该组件。</p>
<p>你可以对重复使用的组件在 <code>main.js</code> 进行全局注册，以减少相应 chunk file 的大小并提高下载速度。</p>
</div></template><script>
export default {
  head: {"title":"Vue 异步加载组件 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// vue-webpack-code-splitting-async-292.vue?59e41573